module.exports = __webpack_public_path__ + "img/icon-banxueleixing@2x.46f3bc50.png";